import { render, staticRenderFns } from "./CustomPackage.vue?vue&type=template&id=eaac7b24"
import script from "./CustomPackage.vue?vue&type=script&lang=js"
export * from "./CustomPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports